import {
    AuthenticationProvider as CommonAuthenticationProvider,
    useAuthContext as useCommonAuthContext
} from "../../../@common/auth/AuthenticationProvider";

export const useAuthContext = useCommonAuthContext;

export const AuthenticationProvider = CommonAuthenticationProvider